module.exports = __webpack_public_path__ + "static/media/_MIC2454.image.a76bd3e5.png";